const AppConsts = {
  apiBaseUrl: "https://expenses.aparajitha.com/api",
};
export default AppConsts;
